import { useAskInputSourceSelection } from '#pplx/frontend/apps/ask/ask-input/ask-input-attributions/hooks/useAskInputSourceSelection.js';
import { useCometTabsPlugins } from '#pplx/frontend/apps/ask/composer-sdk-plugins/comet-tabs/useCometTabsPlugins.js';
import { createConnectorSelectorPluginFactory } from '#pplx/frontend/apps/ask/composer-sdk-plugins/connector-selector/index.js';
import { useAskComposerProjectSelectorPlugin } from '#pplx/frontend/apps/ask/composer-sdk-plugins/project-selector/useAskComposerProjectSelectorPlugin.js';
import { sourceMentionIconPlugin } from '#pplx/frontend/apps/ask/composer-sdk-plugins/source-mention-icon/index.js';
import { useSources } from '#pplx/frontend/apps/ask/sources/hooks/useSources.js';
import { useCallback, useMemo } from 'react';
const connectorSelectorPluginFactory = createConnectorSelectorPluginFactory();
/** Registers existing Ask sources, shared Projects, and eligible Comet controls. */
export function useAskComposerPlusMenuPlugins({ composerRef, cloudFiles, inputJson, initialSources, isComputer, isFollowUp, onSourcesChange, showLeftAttribution = true, showProjects = true, showSources = true, showTabs = true, sources, }) {
    const sourcesEnabled = showLeftAttribution && showSources;
    const { getSourceLabel, isLoading: areSourceLabelsLoading } = useSources({
        enabled: sourcesEnabled,
        productSurface: isComputer ? 'computer' : 'ask',
    });
    const onSourceMentionSelect = useCallback((source, label) => {
        if (composerRef.current === null)
            return false;
        // Let a controlled draft reset commit before restoring its source mentions.
        queueMicrotask(() => {
            composerRef.current?.insertMention({
                id: source,
                kind: 'source',
                text: label,
                icon: { type: 'source', sourceId: source },
            });
        });
        return true;
    }, [composerRef]);
    const onSourceMentionDeselect = useCallback((source) => {
        composerRef.current?.removeMention({ id: source, kind: 'source' });
    }, [composerRef]);
    const { plusMenuSourcesProps } = useAskInputSourceSelection({
        enabled: sourcesEnabled,
        sources,
        onSourcesChange,
        initialSources,
        isComputer,
        isFollowUp,
        inputJson,
        getSourceLabel,
        areSourceLabelsLoading,
        onSourceMentionSelect,
        onSourceMentionDeselect,
    });
    const connectorPlugin = useMemo(() => plusMenuSourcesProps.showSources
        ? connectorSelectorPluginFactory({ ...plusMenuSourcesProps, ...cloudFiles })
        : undefined, [cloudFiles, plusMenuSourcesProps]);
    const projectPlugin = useAskComposerProjectSelectorPlugin({
        composerRef,
        enabled: showLeftAttribution && showProjects,
    });
    const { pickerPlugin, badgePlugin } = useCometTabsPlugins();
    return useMemo(() => [
        sourceMentionIconPlugin,
        ...(connectorPlugin ? [connectorPlugin] : []),
        ...(projectPlugin ? [projectPlugin] : []),
        ...(showLeftAttribution && showTabs && pickerPlugin ? [pickerPlugin] : []),
        ...(showLeftAttribution && showTabs && badgePlugin ? [badgePlugin] : []),
    ], [badgePlugin, connectorPlugin, pickerPlugin, projectPlugin, showLeftAttribution, showTabs]);
}
//# sourceMappingURL=useAskComposerPlusMenuPlugins.js.map